export const ErrorCodes = {
  UNREGISTERED_POSTPAID: '016'
};
